import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from 'sweetalert2'; // Import SweetAlert
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";

const NewRequisitionItemAdd = ({ onSuccess }) => {
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [isModelOpen, setIsModelOpen] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const user = JSON.parse(localStorage.getItem("userDetails"));
    const availableStores = user?.data?.user?.store || [];
    const defaultStore = availableStores[0]?._id || "";

    const [stores, setStores] = useState(availableStores);
    const [selectedStore, setSelectedStore] = useState(defaultStore);
    const [run, setRun] = useState(0);
    const [loading, setLoading] = useState(false);

    const [items, setItems] = useState([
        { name: "", inventory: "", description: "", currentQty: 0, auth: 0, qtyRequired: "", error: "", unit: "", storeRemark: "" },
    ]);
    const [partOptions, setPartOptions] = useState([]);
    const [item, setItem] = useState();

    const handleAddItem = (e) => {
        e.preventDefault();
        const lastItem = items[items.length - 1];

        // Check for required fields
        if (
            !lastItem ||
            !lastItem.inventory ||
            !lastItem.name ||
            lastItem.qtyRequired <= 0 ||
            !lastItem.storeRemark?.trim()
        ) {
            Swal.fire({
                icon: "warning",
                title: "Incomplete Item",
                text: "Please fill Inventory, Qty and Remark before adding new item.",
                confirmButtonText: "OK"
            });
            return;
        }

        setItems([
            ...items,
            { name: "", inventory: "", description: "", currentQty: 0, auth: 0, qtyRequired: "", error: "", unit: "", storeRemark: "" },
        ]);
    };

    const handleItemChange = (index, field, value) => {
    console.log(value);

    const newItems = [...items];
    newItems[index][field] = value;

    if (field === "qtyRequired") {

        const qty = Number(value);

        if (value === "") {
            newItems[index].error = "";
        } else if (qty > (newItems[index].auth - newItems[index].currentQty)) {
            newItems[index].error = "Required Qty cannot be greater than eligible Qty";
        } else if (qty <= 0) {
            newItems[index].error = "Required Qty cannot be 0 or negative";
        } else {
            newItems[index].error = "";
        }

    }

    console.log(newItems);
    setItems(newItems);
};

    const handlePartSelect = (index, selectedOption) => {
        const isDuplicate = items.some(item => item.inventory === selectedOption.value);

        if (isDuplicate) {
            Swal.fire({
                icon: 'error',
                title: 'Duplicate Item',
                text: 'This item has already been added to the requisition.',
                confirmButtonText: 'OK'
            });
            return; // Exit the function if a duplicate is found
        }
        console.log(index, selectedOption);
        handleItemChange(index, "inventory", selectedOption.value);
        handleItemChange(index, "name", selectedOption.label);
        handleItemChange(index, "currentQty", selectedOption.currentStock);
        handleItemChange(index, "auth", selectedOption.auth);
        handleItemChange(index, "description", selectedOption.description); // Set description
        handleItemChange(index, "unit", selectedOption.unit); // Set unit
        handleItemChange(
            index,
            "eligible",
            selectedOption.auth - selectedOption.currentStock
        );
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        let isValid = true;
        let errorMessage = "";

        items.forEach((item, index) => {
            if (item.qtyRequired > item.auth - item.currentQty) {
                isValid = false;
                errorMessage = `Item ${index + 1}: Required Qty cannot exceed eligible Qty`;
            } else if (item.qtyRequired <= 0) {
                isValid = false;
                errorMessage = `Item ${index + 1}: Required Qty must be greater than 0`;
            } else if (!item.storeRemark?.trim()) {
                isValid = false;
                errorMessage = `Item ${index + 1}: Remark is required`;
            }
        });

        if (!isValid) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: errorMessage,
                confirmButtonText: 'OK'
            });
            return;
        }

        setIsSubmitting(true);

        const requestData = {
            store: selectedStore,  // Send store from selected value
            items,
            //fileName: "",          // Optionally allow file/image later
        };

        RequestServies.newSubmitRequisition(requestData)
            .then((response) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Submission Successful',
                    text: 'Your requisition has been submitted successfully!',
                    confirmButtonText: 'OK'
                });

                setItems([
                    { name: "", inventory: "", description: "", currentQty: 0, auth: 0, qtyRequired: "", error: "", unit: "", storeRemark: "" },
                ]);
                setRun(run + 1);
            })
            .catch((error) => {
                console.log('Error during submission:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Submission Failed',
                    text: 'An error occurred while submitting the requisition.',
                    confirmButtonText: 'Try Again'
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };



    const handleRemoveItem = (e, index) => {
        e.preventDefault();
        const newItems = [...items];
        newItems.splice(index, 1);
        setItems(newItems);
    };

    // const handleAddItemSubmit = (event) => {
    //   event.preventDefault(); // Prevent form submission
    //   // Call your API to add the item
    //   const itemToAdd = items[items.length - 1]; // Assuming you're adding the last item
    //   itemToAdd.requisitionNo =  selectedRequisition;

    //   console.log(itemToAdd)
    //   RequestServies.createItem(itemToAdd) // Replace with your actual API call
    //     .then(response => {
    //       console.log('Item added successfully', response);
    //       onSuccess(); // Call the success callback if needed
    //     })
    //     .catch(error => {
    //       console.error('Error adding item', error);
    //     });
    // };



    useEffect(() => {
        const fetchInventory = async () => {
            setLoading(true); // Set loading to true before fetching
            setPartOptions({})
            try {
                const res = await ProductServices.getInventory(selectedStore);
                const options = res.data.data.map((part) => ({
                    value: part._id,
                    label: `${part?.masterItem?.partNo} | ${part?.masterItem?.description}`, // 🟢 Updated label
                    auth: part?.qtyAuth,
                    description: part?.masterItem?.description,
                    currentStock: part?.currentStock,
                    unit: part?.masterItem?.unit?.name

                }));
                setPartOptions(options);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false); // Set loading to false after fetching
            }
        };

        if (selectedStore) {
            fetchInventory();
            setItems([
                { name: "", inventory: "", description: "", currentQty: 0, auth: 0, qtyRequired: "", error: "", unit: "", storeRemark: "" },
            ])
        }
    }, [selectedStore]);


    const handleStoreChange = (e) => {
        setSelectedStore(e.target.value);
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fas fa-filter me-2"></i>Filter
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                onClick={() => setOpen(!open)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-12 col-xxl-2"></div>
                                    <div className="col-xl-12 col-xxl-8">
                                        <label>Select Store</label>
                                        <select
                                            className="form-select mb-xl-0 mb-3"
                                            value={selectedStore}
                                            onChange={handleStoreChange}
                                        >
                                            {stores.map((store) => (
                                                <option key={store._id} value={store._id}>
                                                    {store.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-xl-12 col-xxl-2"></div>

                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>

                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fa fa-plus me-2" aria-hidden="true"></i>Add Requisition Item
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                onClick={() => setOpen2(!open2)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open2}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <div id="content_wrapper" className="dataTables_wrapper no-footer">
                                        <form>
                                            {items.map((item, index) => (
                                                <div key={index} className="row">
                                                    <div className="form-group mb-2 col-md-2">
                                                        <label>Select Inventory</label>
                                                        <Select
                                                            options={loading ? [] : partOptions}
                                                            onChange={(selectedOption) =>
                                                                handlePartSelect(index, selectedOption)
                                                            }
                                                            placeholder={loading ? "Loading..." : "Search by Part No or Description"}
                                                            menuPortalTarget={document.body}
                                                            filterOption={(option, inputValue) =>
                                                                option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                                option.data.description?.toLowerCase().includes(inputValue.toLowerCase())
                                                            }
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    minWidth: 90,
                                                                    height: 14,
                                                                    fontSize: "12px",
                                                                }),
                                                                valueContainer: (base) => ({
                                                                    ...base,
                                                                    height: "100%",
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    height: "auto",
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group mb-2 col-md-2">
                                                        <label>Description</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="description"
                                                            value={item.description}
                                                            placeholder="Description"
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="form-group mb-1 col-md-1">
                                                        <label>Auth Qty</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="auth"
                                                            value={item.auth}
                                                            placeholder="Auth"
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="form-group mb-2 col-md-2">
                                                        <label>
                                                            {item.unit ? `Current Qty (${item.unit})` : `Current Qty`}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="currentQty"
                                                            value={item.currentQty}
                                                            placeholder="Current Qty"
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="form-group mb-2 col-md-2">
                                                        <label>
                                                            {item.unit ? `Eligible Qty (${item.unit})` : `Eligible Qty`}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="eligible"
                                                            value={item.eligible}
                                                            placeholder="Eligible"
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="form-group mb-2 col-md-2">
                                                        <label>
                                                            {item.unit ? `Required Qty (${item.unit})` : `Required Qty`}
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            name="qtyRequired"
                                                            value={item.qtyRequired}
                                                            onChange={(event) =>
                                                                handleItemChange(index, "qtyRequired", event.target.value)
                                                            }
                                                            placeholder="Required Qty"
                                                        />
                                                        <p className="text-danger">{item.error}</p>
                                                    </div>
                                                    <div className="form-group mb-2 col-md-3">
                                                        <label>Remark *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={item.storeRemark}
                                                            placeholder="Enter Remark"
                                                            onChange={(event) =>
                                                                handleItemChange(
                                                                    index,
                                                                    "storeRemark",
                                                                    event.target.value
                                                                )
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group mb-1 col-md-1">
                                                        <button
                                                            className="btn btn-danger btn-xs sharp mt-1"
                                                            onClick={(e) => handleRemoveItem(e, index)}
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}

                                            <div className="row mt-2">
                                                <div className="form-group col-md-2">
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={(e) => handleAddItem(e)}
                                                    >
                                                        Add
                                                    </button>
                                                </div>

                                                <div className="form-group col-md-2">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        onClick={handleSubmit}
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? "Submitting..." : "Submit"}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </div>


    );
};

export default NewRequisitionItemAdd;
